import type {
  ShiftRecord,
  ShiftBreaksList,
  ShiftEventList,
  ShiftMealsList
} from '@libs/data-access/queries'
import type { Moment } from 'moment'
import moment from 'moment'
import { useForm } from 'react-hook-form'

export type FormData = {
  id?: number
  date: Moment | string
  real_starts_at: Moment
  real_ends_at: Moment
  real_breakduration?: number
  witheld_from_pay?: boolean
  shift_breaks_attributes: ShiftBreaksList
  shift_events: ShiftEventList
  shift_meals_attributes: ShiftMealsList
  real_note?: string
  did_not_show?: boolean
  validated_at: null
  validator_id?: number | null
}

type UnvalidateForm = {
  shift: ShiftRecord
}

/**
 * @deprecated
 */
const useUnvalidateShiftFormLegacy = ({ shift }: UnvalidateForm) => {
  const momentRealStart = moment(shift.real_starts_at)
  const momentRealEnd = moment(shift.real_ends_at)

  const formData: FormData = {
    id: shift.id,
    date: moment(shift.starts_at).format('YYYY-MM-DD'),
    real_starts_at: momentRealStart,
    real_ends_at: momentRealEnd,
    real_breakduration: shift.real_breakduration,
    real_note: shift.real_note,
    witheld_from_pay: shift.witheld_from_pay,
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    shift_breaks_attributes: shift.shift_breaks.toJS(),
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    shift_meals_attributes: shift.shift_meals.toJS(),
    shift_events: shift.shift_events,
    did_not_show: shift.did_not_show,
    validator_id: shift.validator_id,
    validated_at: null
  }

  const methods = useForm<FormData>({
    mode: 'onBlur',
    defaultValues: formData
  })

  return {
    methods,
    formData
  }
}

export default useUnvalidateShiftFormLegacy
